import { useEffect, useState } from 'react';
import { 
  Button, Link, Grid, Typography, Container, ListItem, ListItemText,
  IconButton, Alert
} from '@mui/material';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import PinInput from 'react-pin-input';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import { checkCode, addUser, verificarCodigoContacto } from '../../actions/users';
import { login } from '../../actions/auth';
import { isEmpty } from '../common/helpers';

const Step3 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();

  const [verificacion, setVeri] = useState('');
  const [disable, setDisable] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setDisable(verificacion.length!==4);
  }, [verificacion]);

  if(!state || state === undefined) {
    return <Navigate exact to="/signup" />
  }

  const guardar = async e => {
    e.preventDefault();
    setDisable(true);

    const dbInfo = {
      name: state.infoUser.username,
      email: state.infoUser.email,
      avatar: '',
      tel: state.infoUser.tel,
      password: state.infoUser.pass
    };
    // Si no se pudo crear la cuenta, se dice por qué y se puede volver a intentar. Ya creada, entra sola con el correo y la
    // contraseña que acaba de escribir (como la app); si eso falla, el último paso lo dice y manda al login.
    const crear = async (permiso) => {
      const r = await addUser(permiso ? { ...dbInfo, permiso } : dbInfo);
      if (!r.ok) {
        setError(r.error);
        setDisable(false);
        return;
      }
      await dispatch(login(dbInfo.email, dbInfo.password));
      navigate('/signup-last', { state: { status: 'success', celularSinConfirmar: r.celularSinConfirmar } });
    };

    if(state.emailTel === "celular"){
      const info = {
        phonenumber: state.to,
        code: verificacion,
      }
      setDisable(true);
      // El servidor comprueba el código con Twilio y, si es correcto, entrega el permiso para crear la cuenta con ese celular
      const res = await checkCode(info, navigate, true);
      if(res && res.valid){
        await crear(res.permiso);
      } else {
        setDisable(false);
        setError("Código incorrecto");
      }
    } else {
      // El código del correo lo comprueba el servidor y entrega el permiso para crear la cuenta con ese correo
      const r = await verificarCodigoContacto({ canal: 'email', dato: state.infoUser.email, codigo: verificacion });
      if (r.permiso) return crear(r.permiso);
      // Servidor anterior (sin esa ruta): el código venía en la respuesta y se compara aquí, como antes
      if (r.legado && state.infoUser.codigo != null && String(state.infoUser.codigo) === verificacion) return crear();
      setError(r.error || "Código incorrecto");
      setDisable(false);
    }
  }

  return (
    <Container component="main" maxWidth="lg">
      <Grid className="container-steps" container spacing={{ lg: 3}}>
        <Grid className="steps" size={{xs: 12, lg: 4}}>
          <img src="/logo-os-24.svg" alt="OneService" />
          <Typography variant="h5" component="h5">Código</Typography>
          <Grid className="list-steps" size={12}>
            <ListItem className="step-active-second" alignItems="flex-start">
              <ListItemText primary="Selección de verificación" />
            </ListItem>
            <ListItem className="step-active" alignItems="flex-start">
              <ListItemText primary="Código" />
            </ListItem>
          </Grid>
        </Grid>
        <Grid className="form-steps" size={{xs: 12, lg: 8}}>
          <form noValidate onSubmit={guardar}>
            <Grid size={12}>
              <IconButton
                className="btn-icon"
                aria-label="back"
                onClick={() => navigate(-1)}
                sx={{width: 55, height: 55}}
              >
                <ChevronLeftIcon sx={{fontSize: 38}} />
              </IconButton>
            </Grid>
            <Grid container sx={{my:2}} spacing={{sx: 1}}>
              <Grid className="step1" container direction="column">
                <Typography variant="h3" component="h3">Código</Typography>
                <Typography component="p">Introduce el código recibido.</Typography>
              </Grid>
              <Grid size={12}>
                <PinInput
                  length={4}
                  onChange={(value) => setVeri(value)}
                />
              </Grid>
              <Grid size={8} sx={{mt: 3}}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  disabled={disable}
                >
                  Verificar
                </Button>
              </Grid>
            </Grid>
            {
              !isEmpty(error) && (
                <Alert className="mss-alert" severity="error">
                  <Typography component="p" color="error.oscuro">{error}</Typography>
                </Alert>
              )
            }

            <Grid container>
              <Grid size={12}>
                <Typography className="link" component="p">
                  ¿No puedes acceder?
                  {/* En otra pestaña, para no perder el registro. Abre la pregunta del código en /ayuda (preguntasFrecuentes.js):
                      su enlace sale del texto de la pregunta, así que si cambia el texto hay que cambiarlo aquí. */}
                  <Link href="/ayuda#no-me-llega-el-codigo-de-verificacion-que-hago" target="_blank" rel="noopener" underline='none'> - ayuda en línea</Link>
                </Typography>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Container>
  );
}


export default Step3;